import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

export const useSupervisorDetails = () => {
  return useSelector((state: RootState) => state.supervisorDetails.data);
};

export const useUserDetails = () => {
  const supervisorDetails = useSupervisorDetails();
  return supervisorDetails?.data.user || null;
};

export const useHubDetails = () => {
  const supervisorDetails = useSupervisorDetails();
  const selectedHub = useSelector(
    (state: RootState) => state.supervisorDetails.selectedHub
  );
  return (
    supervisorDetails?.data?.hub_list.find((hub) => hub.name === selectedHub) ||
    null
  );
};

export const useDriverDetails = () => {
  return useSelector((state: RootState) => state.driverDetails.details);
};

// Hook to get Hubs of City
export const useHubsOfCity = () => {
  return useSelector((state: RootState) => state.driverDetails.hubsOfCity);
};
